import { render } from "./OurPartnersView.vue?vue&type=template&id=7cff3c5e"
import script from "./OurPartnersView.vue?vue&type=script&lang=js"
export * from "./OurPartnersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__